import { SessionService } from './../../../../../core/session/session.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EnvironmentService } from '@app/core/environment/environment.service';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../../../../core/environment/environment.service";
import * as i3 from "../../../../../core/session/session.service";
var MenuPermissionService = /** @class */ (function () {
    function MenuPermissionService(http, environmentService, sessionService) {
        this.http = http;
        this.environmentService = environmentService;
        this.sessionService = sessionService;
        this.serviceUrl = '/users/menus';
        this.apiUrl = this.environmentService.envModel.appSettings.apiUrlMenu;
        this.iServicesUri = this.environmentService.envModel.appSettings.fm6ApiUrlFeatureToggle;
    }
    MenuPermissionService.prototype.getMenus = function (token) {
        var url = "" + this.apiUrl + this.serviceUrl + "/" + token;
        return this.http.get(url).pipe(catchError(this.handleError), map(this.jsonDataToMenus));
    };
    MenuPermissionService.prototype.jsonDataToMenus = function (jsonData) {
        var menus = [];
        if (jsonData && Array.isArray(jsonData)) {
            jsonData.forEach(function (element) { return menus.push(element); });
        }
        return menus;
    };
    MenuPermissionService.prototype.handleError = function (error) {
        return throwError(error);
    };
    MenuPermissionService.prototype.getMenusiService = function (businessId, gestor) {
        var jwt = this.sessionService.retrieveToken();
        var headers = new HttpHeaders({ Authorization: "Bearer " + jwt });
        var url = this.iServicesUri + "/regras-prime/gestores/" + gestor + "/usuarios/" + businessId;
        return this.http.get(url, { headers: headers });
    };
    MenuPermissionService.ngInjectableDef = i0.defineInjectable({ factory: function MenuPermissionService_Factory() { return new MenuPermissionService(i0.inject(i1.HttpClient), i0.inject(i2.EnvironmentService), i0.inject(i3.SessionService)); }, token: MenuPermissionService, providedIn: "root" });
    return MenuPermissionService;
}());
export { MenuPermissionService };
